export default __webpack_public_path__ + "static/media/endJourneyIcon.93ae1f01.svg";